<script>
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import Contact from "./Contact.svelte";
	import Checkbox from "./Checkbox.svelte";
	import Select from "./Select.svelte";

	import ContactModel from "../models/Contact";
	import AddressModel from "../models/Address";
	import PrimaryButton from "./buttons/PrimaryButton.svelte";

	export let contact = null;
	export let jointHoldings = null;
	export let authorisedToAct = false;
	export let disabled = null;
	export let required = null;

	let disableJoint1 = disabled;
	let mainContactName = "Main Contact";
	$: {
		if (contact.FirstName && contact.Surname) {
			mainContactName = `${contact.FirstName} ${contact.Surname}`;
		} else if (contact.FirstName) {
			mainContactName = contact.FirstName;
		} else if (contact.Surname) {
			mainContactName = contact.Surname;
		} else {
			mainContactName = "Main Contact";
		}
	}

	const sameContactDetails = (event, index) => {
		event.preventDefault();

		jointHoldings[index].JointHoldingContact.Phone = { ...contact.Phone };
		jointHoldings[index].JointHoldingContact.Email = { ...contact.Email };
		jointHoldings[index].JointHoldingContact.Address = { ...contact.Address };
	};

	const handleToggleSameAsContact = (event) => {
		console.log("contact", contact);
		if (event.target.checked) {
			disableJoint1 = true;
			jointHoldings[0].SameAsContact = true;
			jointHoldings[0].JointHoldingContact = contact;
		} else {
			disableJoint1 = null;
			jointHoldings[0].SameAsContact = false;
			jointHoldings[0].JointHoldingContact = getJointHoldingContact();
		}
	};

	const initialise = () => {
		if (!jointHoldings) jointHoldings = [];

		//  Add two Joint Holdings
		if (jointHoldings.length < 2) {
			jointHoldings.push(getJointHolding());
			jointHoldings.push(getJointHolding());
		}
	};

	const getJointHolding = () => {
		let jointHolding = {
			SameAsContact: false,
			JointHoldingContact: getJointHoldingContact()
		};

		return jointHolding;
	};

	const getJointHoldingContact = () => {
		let jointHoldingContact = new ContactModel();
		jointHoldingContact.Address = new AddressModel();

		return jointHoldingContact;
	};

	initialise();
</script>

{#if jointHoldings && jointHoldings.length >= 2}
	<FormRow>
		<FormColumn>
			<h3>Joint Holding Details</h3>
		</FormColumn>
	</FormRow>

	<!-- <FormRow>
		<FormColumn>
			<Checkbox
				{disabled}
				on:change={(event) => handleToggleSameAsContact(event)}
				bind:value={jointHoldings[0].SameAsContact}
				checked={jointHoldings[0].SameAsContact}
				label="Are you a joint holder?"
				id="iscontact"></Checkbox>
		</FormColumn>
	</FormRow> -->

	<FormRow>
		<FormColumn cols="6">
			<h3>Joint Holder 1</h3>
		</FormColumn>
		<!-- <FormColumn cols="6" class="last">
			{#if !disableJoint1}
				<PrimaryButton small={true} on:click={(e) => sameContactDetails(e, 0)}
					>Same contact details as {mainContactName}</PrimaryButton>
			{/if}
		</FormColumn> -->
	</FormRow>

	<Contact
		bind:title={jointHoldings[0].JointHoldingContact.Title}
		bind:firstName={jointHoldings[0].JointHoldingContact.FirstName}
		bind:surname={jointHoldings[0].JointHoldingContact.Surname}
		bind:email={jointHoldings[0].JointHoldingContact.Email}
		bind:phone={jointHoldings[0].JointHoldingContact.Phone}
		bind:address={jointHoldings[0].JointHoldingContact.Address}
		disabled={disableJoint1}
		{required}
		idPrefix="j1"></Contact>

	<FormRow>
		<FormColumn cols="6">
			<h3>Joint Holder 2</h3>
		</FormColumn>
		<!-- <FormColumn cols="6" class="last">
			{#if !disabled}
				<PrimaryButton small={true} on:click={(e) => sameContactDetails(e, 1)}
					>Same contact details as {mainContactName}</PrimaryButton>
			{/if}
		</FormColumn> -->
	</FormRow>

	<Contact
		bind:title={jointHoldings[1].JointHoldingContact.Title}
		bind:firstName={jointHoldings[1].JointHoldingContact.FirstName}
		bind:surname={jointHoldings[1].JointHoldingContact.Surname}
		bind:email={jointHoldings[1].JointHoldingContact.Email}
		bind:phone={jointHoldings[1].JointHoldingContact.Phone}
		bind:address={jointHoldings[1].JointHoldingContact.Address}
		{disabled}
		{required}
		idPrefix="j2"></Contact>
{/if}

<FormRow>
	<FormColumn>
		<Checkbox
			{disabled}
			bind:checked={authorisedToAct}
			label="I am authorised to act on behalf of the Joint Holder"
			{required}
			id="authjh"></Checkbox>
	</FormColumn>
</FormRow>
